/**
 * Types-to-filter for long facet lists — in practice, the designer list.
 *
 * Hides rows whose label does not contain what was typed. Purely visual: it
 * never touches the checkboxes, so a designer ticked and then typed past stays
 * ticked and still applies. Clearing the box brings everything back.
 *
 * Delegated from the document because these lists are re-rendered whenever a
 * filter changes, which would strip any listener bound to the input itself.
 */
(function () {
  const ROW = '.facets__inputs-list-item';

  /**
   * @param {HTMLInputElement} input
   */
  function applyFilter(input) {
    const scope = input.closest('facet-inputs-component') || input.parentElement?.parentElement;
    if (!scope) return;

    const term = input.value.trim().toLowerCase();
    const rows = scope.querySelectorAll(ROW);
    let shown = 0;

    rows.forEach((row) => {
      const label = (row.textContent || '').trim().toLowerCase();
      const match = term === '' || label.includes(term);
      row.hidden = !match;
      if (match) shown += 1;
    });

    // Nothing matched: say so rather than leaving a blank panel, which is the
    // same confusion the scrollbar was added to avoid.
    let empty = scope.querySelector('[data-facet-search-empty]');
    if (!empty) {
      empty = document.createElement('p');
      empty.setAttribute('data-facet-search-empty', '');
      empty.className = 'facets__search-empty';
      scope.appendChild(empty);
    }
    empty.textContent = 'No matches';
    empty.hidden = shown !== 0;
  }

  document.addEventListener('input', (event) => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.hasAttribute('data-facet-search')) {
      applyFilter(target);
    }
  });

  // A search input fires this on the native clear button in some browsers.
  document.addEventListener('search', (event) => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.hasAttribute('data-facet-search')) {
      applyFilter(target);
    }
  });
})();
